// test2550
(2550 && 0);
